export const REEL_MAX_VIDEO_SIZE = 1024 * 1024 * 500;
